<div class="flex flex-col container box-border items-center gap-6 my-14 p-14">
    <div>
        <img src="/assets/images/error-404.png" />
    </div>
    <div data-testid="error-page-title">
        <strong class="ca-headline-1 mb-0">{{ 'COMMON.ERRORS.404.TITLE' | translate }}</strong>
    </div>
    <div class="flex flex-col items-center gap-6">
        <div>
            {{ 'COMMON.ERRORS.404.CONTENT' | translate }}
        </div>
        <div class="flex justify-center mt-6">
            <button mat-stroked-button class="ca-button mt-auto" routerLink="/projects" data-testid="error-page-link">
                <ca-icon icon="arrow-left" class="ca-icon-s"></ca-icon>
                <span>{{ 'NAVBAR.PROJECTS' | translate }}</span>
            </button>
        </div>
    </div>
</div>
